import { OpusJobsHeader } from './opus-jobs-header.component';
import { OpusJobsTableComponent } from './opus-jobs-table.component';
import { OpusJobsTableRowComponent } from './opus-jobs-table-row.component';

export const components: any[] = [OpusJobsHeader, OpusJobsTableComponent, OpusJobsTableRowComponent];

export * from './opus-jobs-header.component';
export * from './opus-jobs-table.component';
export * from './opus-jobs-table-row.component';
